// extracted by mini-css-extract-plugin
export default {"delete":"DeleteProjectModal_delete__9BkZn","action-btn":"DeleteProjectModal_action-btn__Qq6Nf"};